import { useState } from "react";
import { AiOutlineCar } from "react-icons/ai";
import VehiclePanel from "./VehiclePanel";

export default function WidgetTT({ currInVehicles, currOutVehicles }: any) {
  const [showDetails, setShowDetails] = useState(false);

  const count = currInVehicles?.length + currOutVehicles?.length;

  const allVehicles = [...currInVehicles, ...currOutVehicles];
  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-200 cursor-pointer mb-2">
      <button
        onClick={() => setShowDetails(true)}
        className="py-2 px-3 flex flex-row items-center "
      >
        <div className="bg-green-100 p-4 rounded-full text-toyota font-bold text-lg">
          <AiOutlineCar size={35} color="#4ca832" />
        </div>
        <div className="flex flex-col ml-2 justify-center">
          <div className="text-md text-gray-800 font-bold uppercase truncate">
            <span className="text-green-700">Arrived</span>
          </div>
          <div className="flex  justify-between items-center text-sm">
            <div className="rounded-md text-black text-3xl font-bold">
              {count}
            </div>
          </div>
        </div>
      </button>
      <VehiclePanel
        isVisible={showDetails}
        setShowDetails={setShowDetails}
        vehicles={allVehicles}
        title={"Vehicles Arrived : Today"}
      />
    </div>
  );
}
